import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

/**
 *
 * @param {*} param
 */
const _renderSwitch = (param, value) => {
    switch (param) {
        case 'percent':
            return <Text small>{`${ value }%` }</Text>;
        case 'header':
            return <Text small bold>{value}</Text>;
        case 'age':
            return <Text small>{value}</Text>;
        case 'days':
            return <Text small> {value === 0 ? 'none' : value === 1 ? '1 day' : `${ value } days` } </Text>;
        default:
            return <Text small>{ `$${ helpers.numberWithCommasDecimals(value) }` }</Text>;
    }
};

/**
 *
 * @param {*} param0
 */
const CoverageBlock = ({ title, value, type, isCombined }) => {
    const styles = {
        row: {
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
            marginTop: 5
        }
    };
    return(
        <div style={styles.row}>
            <Text small bold={type === 'header'} customStyle={{ flex: 1 }}>{title}</Text>
            {!isCombined && _renderSwitch(type, value)}
        </div>
    );
};

export default (CoverageBlock);